import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	grabbed: {
		id: 'platform-board-kit-legacy-dnd.board-drag-drop-context.grabbed',
		defaultMessage:
			'{dndType, select, COLUMN {Column} other {Card}} {issueKey} grabbed. Current Position is {fromPosition} of {totalCards} in the {columnName} {ignoreDndTypeInMessage, select, true {} other {column}}. Use the arrow keys to move, space-bar to drop and escape to cancel.',
		description: 'Screen reader announce message when issue card start dragging.',
	},
	movedBackPosition: {
		id: 'platform-board-kit-legacy-dnd.board-drag-drop-context.moved-back-position',
		defaultMessage:
			"You've moved {issueKey} back to its original position in the {columnName} {ignoreDndTypeInMessage, select, true {} other {column}}.",
		description:
			'Screen reader announce message when issue card moved back into the original position.',
	},
	movedNewPosition: {
		id: 'platform-board-kit-legacy-dnd.board-drag-drop-context.moved-new-position',
		defaultMessage: `You've moved {issueKey} from position {fromPosition} to position {
            toPosition
        } of {totalCards} in the {columnName} {ignoreDndTypeInMessage, select, true {} other {Column}}.`,
		description: 'Screen reader announce message when issue card moved into a new position.',
	},
	movedNewColumn: {
		id: 'platform-board-kit-legacy-dnd.board-drag-drop-context.moved-new-column',
		defaultMessage:
			"You've moved {issueKey} to position {toPosition} in the {columnName} {ignoreDndTypeInMessage, select, true {} other {column}}.",
		description: 'Screen reader announce message when issue card moved into a new column.',
	},
	dropped: {
		id: 'platform-board-kit-legacy-dnd.board-drag-drop-context.dropped',
		defaultMessage:
			"You've dropped {issueKey} in the {columnName} {ignoreDndTypeInMessage, select, true {} other {column}}. Final position is {toPosition} of {totalCards}",
		description: 'Screen reader announce message when issue card dropped into a new position.',
	},
});
